import { globalTourSteps } from 'constants/tour';

export const clusterDashboardTourId = 'cluster-dashboard';

export const tourSteps = {
  details: 'details',
  gauges: 'gauges',
  charts: 'charts',
};

export const clusterDashboardStepsOrder = [
  tourSteps.details,
  tourSteps.gauges,
  tourSteps.charts,
  globalTourSteps.connectMyCluster,
];
